import React from 'react';
import { Button } from '@ublend-npm/aulaui-next';

export type EditorActionButtonProps = {
  id: string;
  label: string;
  disabled?: boolean;
  hideWhenBlurred?: boolean;
  onClick?: (event: Event) => void;
};

export const EditorActionButton = ({
  id,
  label,
  disabled,
  onClick,
}: EditorActionButtonProps) => (
  <Button
    type="primary"
    id={id}
    onClick={(e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      if (!disabled && onClick) {
        onClick(e);
      }
    }}
    aria-label="Send"
    disabled={disabled}
    aria-disabled={disabled}
    tabIndex={disabled ? '-1' : '0'}
  >
    {label}
  </Button>
);
